maybeGetServerSnapshot